// extracted by mini-css-extract-plugin
export default {"double":"minimum-value_double__KrXMY","doubleInput":"minimum-value_doubleInput__Cz7zT"};